import PropTypes from 'prop-types'

import { getDisplayName } from 'utils/mixpanel'

import {
  ERROR_STATUS,
  PAID_STATUS,
  PROCESSING_STATUS,
  REFUND_ERROR,
  REFUND_PROCESSING_STATUS,
  REFUND_STATUS,
  getPaymentInfo,
} from 'payments/payments.transformations'

export const formatOrders = (
  orders,
  orderPaymentRecords,
  invoices,
  manualPaymentRecords,
) => {
  const formattedOrders = orders.map((order) => ({
    ...order,
    paymentRecords: getPaymentInfo(
      order.id,
      orderPaymentRecords,
      manualPaymentRecords,
    ),
    invoices: invoices.filter((invoice) => invoice.orderId === order.id),
  }))

  return formattedOrders
}

export const withFormatter = (WrappedComponent) => {
  const Wrapper = (props) => {
    const { orders, orderPaymentData, invoices, manualPaymentRecords } = props
    const formattedOrders =
      orders && orderPaymentData && invoices
        ? formatOrders(orders, orderPaymentData, invoices, manualPaymentRecords)
        : []
    const newProps = {
      ...props,
      orders: formattedOrders,
    }

    return <WrappedComponent {...newProps} />
  }

  Wrapper.propTypes = {
    orders: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
      }),
    ),
    orderPaymentData: PropTypes.arrayOf(
      PropTypes.shape({
        orderId: PropTypes.string,
        amount: PropTypes.number,
        currencyCode: PropTypes.string,
        status: PropTypes.oneOf([
          PAID_STATUS,
          REFUND_STATUS,
          PROCESSING_STATUS,
          REFUND_PROCESSING_STATUS,
          REFUND_ERROR,
          ERROR_STATUS,
        ]),
        date: PropTypes.string,
      }),
    ),
  }
  Wrapper.defaultProps = {
    orders: [],
    orderPaymentData: [],
  }
  Wrapper.displayName = `withFormatter(${getDisplayName(WrappedComponent)})`

  return Wrapper
}

export default withFormatter
